import { render, staticRenderFns } from "./SaveAndResetSlot.vue?vue&type=template&id=9e6f66c6&"
import script from "./SaveAndResetSlot.vue?vue&type=script&lang=js&"
export * from "./SaveAndResetSlot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports